<template>
  <div id="pagination-and-sort-by" class="row mb-3 mb-lg-0">
    <Pagination
      :total_pages="totalPages"
      :selected_page="selectedPage"
      :total_items="totalItems"
      v-on="{ 'on-set-page': emitChangePage }"
    />
  </div>
</template>

<script>
import Pagination from "@/components/Utils/Pagination.vue";
export default {
  name: "MyProjectsPagination",
  components: { Pagination },

  props: [
    "totalPages",
    "selectedPage",
    "totalItems",
    "sortedBy",
    "sortedByOptions",
    "showArchivedProjects",
    "showSortByDropdown",
    "showCheckboxForArchiveProjects",
  ],

  methods: {
    emitChangePage(pageNumber) {
      this.$emit("on-set-page", pageNumber);
    },
    emitSortBy(e) {
      const sortOpt = e.target.value;
      this.$emit("on-sort-by", sortOpt);
    },
    emitToggleShowArchivedProjects() {
      this.$emit("on-toggle-checkbox");
    },
  },
};
</script>

<style lang="scss" scoped>
#pagination-and-sort-by {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-left: auto;
  margin-right: 0;
  ::v-deep .pagination {
    margin-left: auto;
    margin-right: 0;
  }
}
</style>